









































































































































































































import { BidStatus } from '@/enums/BidStatus'
import { TenderWinnersDTO } from '@/services/tender/types'
import { formatDate, formatDateTime, formatDateTimeAL, parseAndJoin, renderDeliveryProfile } from '@/utils/helpers'
import BidActions from '@/views/Tender/components/BidActions.vue'
import LotWinningStatus from '@/views/Tender/partials/LotWinningStatus.vue'
import { defineComponent } from '@vue/composition-api'
import html2canvas from 'html2canvas'

export default defineComponent({
  name: 'TenderBid',
  setup() {
    return { formatDate, renderDeliveryProfile, parseAndJoin, formatDateTime, formatDateTimeAL }
  },
  components: { LotWinningStatus, BidActions },
  props: {
    lot: {
      type: Object as () => TenderWinnersDTO,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
    biddable: {
      type: Boolean,
      default: true,
    },
    procurementId: {
      type: Number,
      required: true,
    },
    procurementDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    profileInfo: {
      get(): string {
        return renderDeliveryProfile(this.lot.deliveryProfile ?? [])
      },
      set(value: string): void {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    refreshTenderDetails() {
      this.$emit('refresh')
    },
    calculatedTotal(pricePerUnit: number, quantity: number): number {
      return pricePerUnit && quantity ? pricePerUnit * quantity : 0
    },
    calculatedRemainingPower(offeredPower: number, purchasedPower: number): number {
      return offeredPower && purchasedPower ? offeredPower - purchasedPower : 0
    },
    calculatedQuantity(power: number, hours: number): number {
      return power && hours ? power * hours : 0
    },
    isWinnerLot(key: number) {
      return this.lot.lotBids[key].isWinner && this.lot.lotBids[key].status === BidStatus.CONFIRMED
    },
    isNotWinnerLot(key: number) {
      return !this.lot.lotBids[key].isWinner && this.lot.lotBids[key].status === BidStatus.NOT_APPROVED
    },
    shouldDisplayStatus(key: number) {
      return this.isWinnerLot(key) || this.isNotWinnerLot(key)
    },
    isPending(key: number) {
      return this.lot.lotBids[key].status === BidStatus.PENDING
    },
    async downloadAsPng(bidId: number) {
      const div = document.getElementById(`lotBid-${bidId}`)

      if (!div) {
        console.error('Div not found!')
        return
      }

      try {
        const itemsToHide = div.querySelectorAll('.item-to-hide')
        itemsToHide.forEach((item) => {
          const element = item as HTMLElement
          element.style.display = 'none'
        })

        const canvas = await html2canvas(div)
        const image = canvas.toDataURL('image/png')

        const link = document.createElement('a')
        link.href = image
        link.download = 'screenshot.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        itemsToHide.forEach((item) => {
          const element = item as HTMLElement
          element.style.display = ''
        })
      } catch (error) {
        console.error('Error capturing the div:', error)
      }
    },
    async printDiv(bidId: number) {
      const div = document.getElementById(`lotBid-${bidId}`)

      if (!div) {
        console.error('Div not found!')
        return
      }

      try {
        const itemsToHide = div.querySelectorAll('.item-to-hide')
        itemsToHide.forEach((item) => {
          const element = item as HTMLElement
          element.style.display = 'none'
        })

        const canvas = await html2canvas(div, {
          scale: 2,
          useCORS: true,
          logging: true,
          scrollX: 0,
          scrollY: 0,
        })
        const image = canvas.toDataURL('image/png')

        const printWindow = window.open('', '', 'width=800, height=600')
        const procurementDateStr = this.procurementDate ? formatDate(this.procurementDate) : 'N/A'
        printWindow?.document.write(`
           <html>
             <head>
               <title>Print</title>
               <style>
                 @page {
                   margin: 0;
                   size: auto;
                 }
                 body {
                   margin: 0;
                   padding: 20px;
                   font-family: Arial, sans-serif;
                 }
                 .print-header {
                   margin-bottom: 20px;
                   padding-bottom: 10px;
                   border-bottom: 1px solid #000;
                 }
                 .print-date {
                   font-size: 14px;
                   font-weight: bold;
                 }
               </style>
             </head>
             <body>
               <div class="print-header">
                 <div class="print-date">${procurementDateStr}</div>
               </div>
               <img src="${image}" style="max-width: 100%; height: auto;" />
             </body>
           </html>
         `)
        printWindow?.document.close()

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print()
            printWindow.close()
          }
        }

        itemsToHide.forEach((item) => {
          const element = item as HTMLElement
          element.style.display = ''
        })
      } catch (error) {
        console.error('Error printing the div:', error)
      }
    },
  },
})
